import React, { useEffect, useState } from 'react';
import { useTitle } from '../contexts/TitleContext';
import { Box, Pagination, CircularProgress, Typography } from '@mui/material';
import { useFetchBidRecommendationRunsQuery } from '../slices/bidRecommendationSlice';
import RunCard from '../components/BidRecommendations/RunCard';
import RunDetailView from '../components/BidRecommendations/RunDetailView';

const PAGE_SIZE = 10;

const BidRecommendations: React.FC = () => {
  const { setTitle } = useTitle();
  const [page, setPage] = useState(1);
  const [selectedRunId, setSelectedRunId] = useState<string | null>(null);

  useEffect(() => {
    setTitle('Bid Recommendations');
  }, [setTitle]);

  const { data, isLoading } = useFetchBidRecommendationRunsQuery({
    page,
    pageSize: PAGE_SIZE,
  });

  if (selectedRunId) {
    return (
      <RunDetailView
        runId={selectedRunId}
        onBack={() => setSelectedRunId(null)}
      />
    );
  }

  return (
    <Box display="flex" flexDirection="column" width="100%" maxWidth="82vw">
      <Typography variant="h5" sx={{ mt: 2, mb: 2 }}>
        Analysis Runs
      </Typography>

      {isLoading && (
        <Box display="flex" justifyContent="center" py={6}>
          <CircularProgress />
        </Box>
      )}

      {data && data.runs.length === 0 && (
        <Typography color="text.secondary" sx={{ py: 4, textAlign: 'center' }}>
          No recommendation runs yet. Runs will appear here after the scheduled
          analysis submits recommendations.
        </Typography>
      )}

      {data &&
        data.runs.map((run) => (
          <RunCard
            key={run.id}
            run={run}
            onClick={() => setSelectedRunId(run.id)}
          />
        ))}

      {data && data.total > PAGE_SIZE && (
        <Box display="flex" justifyContent="center" mt={2}>
          <Pagination
            count={Math.ceil(data.total / PAGE_SIZE)}
            page={page}
            onChange={(_, v) => setPage(v)}
            color="primary"
          />
        </Box>
      )}
    </Box>
  );
};

export default BidRecommendations;
